import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog'
import { PDFComponent, IPDF } from '../shared/dialogs/pdf.component';
import { LoginComponent } from '../shared/dialogs/login.component';
import { ANONIMOComponent } from '../shared/dialogs/anonimo.component';



@Injectable()
export class DialogService {

  constructor(protected _dialog: MatDialog) { }

  openPDFDialog(dataComponent: IPDF) {
    this._dialog.closeAll();
    let ref;
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)&& dataComponent.source!='app') {
      // console.log(navigator.userAgent);
      var anchor = document.createElement('a');
      anchor.href = dataComponent.content.data;
      anchor.download = dataComponent.title + ".pdf"
      anchor.click();
      anchor.target='_blank'; 
      ref = null;
    }
    else {
      ref = this._dialog.open(PDFComponent, {
        autoFocus: false,
        width: '80vw',
        maxWidth: '90vw',
        height: '100vh',
        disableClose: false,
        panelClass: 'pdf-dialog-container',
        data: dataComponent
      })
    }
    return ref;
  }

  openLoginDialog() {
    this._dialog.closeAll();
    let ref = this._dialog.open(LoginComponent, {
      autoFocus: false,
      width: '50vw',
      maxWidth: '90vw',
      disableClose: false,
      panelClass: 'login-dialog-container',
      data: {
        title: "Login - Bennet.com",
        actions: [
          { 'label': 'Login', 'value': 1 ,category:'success'},
         ]
      }
    })
    return ref
  }

  openAnonimoDialog(data){
    this._dialog.closeAll();
    let ref = this._dialog.open(ANONIMOComponent, {
      autoFocus: false,
      width: '32vw',
      maxWidth: '34vw',
      disableClose: false,
      panelClass: 'login-dialog-container',
      data:  data
      })
      return ref;
    }
 
}



// WEBPACK FOOTER //
// ./src/app/theme/services/dialog.service.ts